// extracted by mini-css-extract-plugin
export default {"infoBlock":"j5e0xyUf","icon":"EbNoUQHn","infoIcon":"BuZaSe1D","infoText":"kcQHaY9s","title":"hJ8sERIT","avatars":"sxEBW18G","avatar":"KVCiVlpY"};